import { Component } from '@angular/core';

@Component({
    templateUrl: './faculty-courses-help.component.html',
    styleUrls: ['./faculty-courses-help.component.scss'],
    standalone: false
})
export class FacultyCoursesHelpComponent{}

